export default {"src":"/_next/static/media/chevron_left.7ae6a887.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};